import { applicantDashboardConstants } from "../../_constants/hiringManager/applicantDashboard.constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

// get applicant profile
export const get_applicant_profile_info_action = (id) => async (dispatch) => {
  dispatch({
    type: applicantDashboardConstants.GET_APPLICANT_PROFILE_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.hiringManager.applicantProfile.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: applicantDashboardConstants.GET_APPLICANT_PROFILE_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: applicantDashboardConstants.GET_APPLICANT_PROFILE_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

// get applicant hiring progress details
export const get_applicant_hiring_progress_action =
  (id) => async (dispatch) => {
    dispatch({
      type: applicantDashboardConstants.GET_APPLICANT_HIRING_PROGRESS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.hiringManager.getHiringProgressDetails.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: applicantDashboardConstants.GET_APPLICANT_HIRING_PROGRESS_ACTION_SUCCESS,
          payload: response.data.data,
        });
        return response.data.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: applicantDashboardConstants.GET_APPLICANT_HIRING_PROGRESS_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

// get applicant comments List
export const get_applicant_comments_list_action =
  (id, stage) => async (dispatch) => {
    dispatch({
      type: applicantDashboardConstants.GET_COMMENTS_LIST_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.hiringManager.getCommentList}${id}/${stage}/`
      );
      // const response = await axiosInstance.get(config.hiringManager.getCommentList.replace(':id', id,':stage',stage));

      if (response.status) {
        dispatch({
          type: applicantDashboardConstants.GET_COMMENTS_LIST_ACTION_SUCCESS,
          payload: response.data.data,
        });
        return response.data.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: applicantDashboardConstants.GET_COMMENTS_LIST_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

// create hiring Progress action
export const create_applicant_comment_action = (data) => async (dispatch) => {
  dispatch({
    type: applicantDashboardConstants.CREATE_COMMENT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.hiringManager.createComment,
      data
    );
    if (response.status) {
      dispatch({
        type: applicantDashboardConstants.CREATE_COMMENT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: applicantDashboardConstants.CREATE_COMMENT_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//update applicant hiring progress action
export const update_applicant_comment_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: applicantDashboardConstants.UPDATE_COMMENT_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.hiringManager.updateComment.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: applicantDashboardConstants.UPDATE_COMMENT_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: applicantDashboardConstants.UPDATE_COMMENT_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//update applicant hiring progress action
export const delete_applicant_comment_action = (id) => async (dispatch) => {
  dispatch({
    type: applicantDashboardConstants.UPDATE_COMMENT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.delete(
      config.hiringManager.updateComment.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: applicantDashboardConstants.UPDATE_COMMENT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: applicantDashboardConstants.UPDATE_COMMENT_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//update applicant hiring progress action
export const get_applicant_hms_videos_action = (id) => async (dispatch) => {
  dispatch({
    type: applicantDashboardConstants.GET_APPLICANT_HMS_VIDEOS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.hiringManager.getApplicantHmsVideos.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: applicantDashboardConstants.GET_APPLICANT_HMS_VIDEOS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: applicantDashboardConstants.GET_APPLICANT_HMS_VIDEOS_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//update applicant hiring progress action
export const create_applicant_offer_terms_action =
  (data) => async (dispatch) => {
    dispatch({
      type: applicantDashboardConstants.CREATE_APPLICANT_OFFER_TERMS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.hiringManager.createApplicantJobOffer,
        data
      );
      if (response.status) {
        dispatch({
          type: applicantDashboardConstants.CREATE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Offer Terms sent.");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: applicantDashboardConstants.CREATE_APPLICANT_OFFER_TERMS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
    }
  };

export const update_applicant_offer_terms_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: applicantDashboardConstants.UPDATE_APPLICANT_OFFER_TERMS_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.hiringManager.appllicantJobOfferById.replace(":id", id),
        data
      );
      if (response.status) {
        showSuccessMessage("Offer terms updated.")
        dispatch({
          type: applicantDashboardConstants.UPDATE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: applicantDashboardConstants.UPDATE_APPLICANT_OFFER_TERMS_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

export const delete_applicant_offer_terms_action = (id) => async (dispatch) => {
  dispatch({
    type: applicantDashboardConstants.DELETE_APPLICANT_OFFER_TERMS_ACTION_REQUEST,
  });
  try {
    const response = {};
    // await axiosInstance.delete(
    //   config.hiringManager.getApplicantHmsVideos.replace(":id", id)
    // );
    if (response.status) {
      dispatch({
        type: applicantDashboardConstants.DELETE_APPLICANT_OFFER_TERMS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: applicantDashboardConstants.DELETE_APPLICANT_OFFER_TERMS_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

export const get_applicant_offer_terms_action = (id) => async (dispatch) => {
  dispatch({
    type: applicantDashboardConstants.GET_APPLICANT_OFFER_TERMS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.hiringManager.appllicantJobOfferById.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: applicantDashboardConstants.GET_APPLICANT_OFFER_TERMS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: applicantDashboardConstants.GET_APPLICANT_OFFER_TERMS_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

export const get_applicant_submitted_assessment_kits_action = (id) => async (dispatch) => {
  dispatch({
    type: applicantDashboardConstants.GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.hiringManager.applicantSubmittedAssessmentKits.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: applicantDashboardConstants.GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: applicantDashboardConstants.GET_APPLICANT_SUBMITTED_ASSESSMENT_KITS_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};


export const reset_applicant_dashboard_action = (id) => async (dispatch) => {
  dispatch({
    type: applicantDashboardConstants.RESET_ACTION,
  });
  
};